// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"fabcc50c","513":"11b3e316","703":"3a71d58c"}[chunkId] + ".chunk.js";
};